import { render } from "./BookingDetails.vue?vue&type=template&id=1c2a0176&scoped=true"
import script from "./BookingDetails.vue?vue&type=script&lang=js"
export * from "./BookingDetails.vue?vue&type=script&lang=js"

import "./BookingDetails.vue?vue&type=style&index=0&id=1c2a0176&lang=scss&scoped=true"
import "./BookingDetails.vue?vue&type=style&index=1&id=1c2a0176&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2a0176"]])

export default __exports__